import Web3 from 'web3';
import FavoritesContract from '../contracts/ethereumFavoritesContract.js';
import UsersContract from '../contracts/usersContract.js';
import GuildSamplesContract from '../contracts/GuildSamplesContract.js';
import TokenizedSequencesContract from '../contracts/TokenizedSequencesContract.js';
import GuildSequencesContract from '../contracts/GuildSequencesContract.js';
import GuildPresetsContract from '../contracts/GuildPresetsContract.js';
import GuildsContract from '../contracts/GuildsContract.js';
import EncryptionContract from '../contracts/EncryptionContract.js';
import FoldersContract from '../contracts/FoldersContract.js';
import MessagingContract from '../contracts/MessagingContract.js';
import SequenceMetadataContract from '../contracts/SequenceMetadataContract.js';
import ResampleContract from '../contracts/ResampleContract.js';
import XanaduContract from '../contracts/XanaduContract.js';
import MixContract from '../contracts/MixContract.js';
import EffectsContract from '../contracts/EffectsContract.js';
import ArtistsContract from '../contracts/ArtistsContract.js';
import GuildSettingsContract from '../contracts/GuildSettingsContract.js';
import MidiCCContract from '../contracts/MidiCCContract.js';
import ExploreListsContract from '../contracts/ExploreListsContract.js';
import WallpaperContract from '../contracts/WallpaperContract.js';
import PacksContract from '../contracts/PacksContract.js';
import ScriptsContract from '../contracts/ScriptsContract.js';
import {web3} from '../web3.js';

export const USERS = 'USERS';
export const GUILD_SAMPLES = 'GUILD_SAMPLES';
export const FAVORITES = 'FAVORITES';
export const TOKENIZED_SEQUENCES = 'TOKENIZED_SEQUENCES';
export const GUILD_SEQUENCES = 'GUILD_SEQUENCES';
export const GUILD_PRESETS = 'GUILD_PRESETS';
export const GUILDS = 'GUILDS';
export const ENCRYPTION = 'ENCRYPTION';
export const FOLDERS = 'FOLDERS';
export const MESSAGING = 'MESSAGING';
export const SEQUENCE_METADATA= 'SEQUENCE_METADATA';
export const RESAMPLE = 'RESAMPLE';
export const XANADU = 'XANADU';
export const MIX = 'MIX';
export const EFFECTS = 'EFFECTS';
export const ARTISTS = 'ARTISTS';
export const GUILD_SETTINGS = 'GUILD_SETTINGS';
export const MIDI_CC= 'MIDI_CC';
export const EXPLORE_LISTS = 'EXPLORE_LISTS';
export const WALLPAPER = 'WALLPAPER';
export const PACKS = 'PACKS';
export const SCRIPTS = 'SCRIPTS';

export const contracts = {
    USERS: new UsersContract().getContract(web3),
    FAVORITES: new FavoritesContract().getContract(web3),
    GUILDS: new GuildsContract().getContract(web3),
    GUILD_SAMPLES: new GuildSamplesContract().getContract(web3),
    TOKENIZED_SEQUENCES: new TokenizedSequencesContract().getContract(web3),
    GUILD_SEQUENCES: new GuildSequencesContract().getContract(web3),
    GUILD_PRESETS: new GuildPresetsContract().getContract(web3),
    ENCRYPTION: new EncryptionContract().getContract(web3),
    FOLDERS: new FoldersContract().getContract(web3),
    MESSAGING: new MessagingContract().getContract(web3),
    SEQUENCE_METADATA: new SequenceMetadataContract().getContract(web3),
    RESAMPLE: new ResampleContract().getContract(web3),
    XANADU: new XanaduContract().getContract(web3),
    MIX: new MixContract().getContract(web3),
    EFFECTS: new EffectsContract().getContract(web3),
    ARTISTS: new ArtistsContract().getContract(web3),
    GUILD_SETTINGS: new GuildSettingsContract().getContract(web3),
    MIDI_CC: new MidiCCContract().getContract(web3),
    EXPLORE_LISTS: new ExploreListsContract().getContract(web3),
    WALLPAPER: new WallpaperContract().getContract(web3),
    PACKS: new PacksContract().getContract(web3),
    SCRIPTS: new ScriptsContract().getContract(web3)
};

    

